export const filterAccountDetailsData = (data, state) => {
  const sendPayements = state.sendPayments;
  const receivePayements = state.receivePayments;
  if (isPaymentsUpdated(data.send_payments, sendPayements)) {
    data.send_payments = data.send_payments.filter(item =>
      sendPayements ? sendPayements.find(v => v === Object.keys(item)[0]) : true
    );
  }
  if (isPaymentsUpdated(data.receive_payments, receivePayements)) {
    data.receive_payments = data.receive_payments.filter(item =>
      receivePayements ? receivePayements.find(v => v === Object.keys(item)[0]) : true
    );
  }
  if (!isPaymentOfType(data)) {
    delete data.cashDeposit;
  }
  return data;
};

const isPaymentsUpdated = (data, payments) =>
  data && payments && payments.length > 0 && !isContentChange(data, payments);

const isContentChange = (cur, pre) => JSON.stringify(cur) === JSON.stringify(pre);
const isPaymentOfType = data => data.paymentOfType.find(v => v === 'Cash') && data.cashDeposit;
